<template>
  <div class="modal-wrapper">
    <div class="modal" v-on-clickaway="closeModal">
      <slot></slot>
      <footer>
        <button type="button" class="default" @click="closeModal">
          <close-icon width="15px" height="15px"></close-icon>
          {{ $t("dashboard-modal-cancel") }}
        </button>
        <button type="button" class="primary" @click="confirm">
          {{ $t("modal-ok-button") }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
import CloseIcon from "@/components/icons/CloseIcon";

export default {
  name: "ConfirmModal",
  mixins: [clickaway],
  components: {
    CloseIcon
  },
  methods: {
    closeModal() {
      this.$emit("confirmClose");
    },
    confirm() {
      this.$emit("confirmOk");
    }
  }
};
</script>

<style scoped lang="scss">
@import "../assets/styles/variables";

.modal-wrapper {
  z-index: 6;
  .modal {
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    position: relative;
    width: 50%;
    max-width: 700px;
    border: 1px solid $middle-gray;
    border-radius: 8px;
    padding: 10px 20px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
    background: white;
    footer {
      margin: 30px 0 10px 0;
      display: flex;
      justify-content: space-between;
      button {
        min-width: 120px;
      }
    }
  }
}
</style>
